import React, { useState } from 'react';
import axios from 'axios';
import './ReviewModal.css';
import { API } from '../services/apiConfig';

function ReviewModal({ orderId, productId, productName, userId, userName, userEmail, onClose, onSuccess }) {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) { alert('Please select a rating'); return; }
    if (!productId) { alert('Product ID is required'); return; }
    setSubmitting(true);
    const resolvedName = (userName && userName.trim() && userName !== 'null')
      ? userName.trim()
      : (userEmail || 'User');
    try {
      await axios.post(
        `${API}/api/orders/${orderId}/review?userId=${userId}`,
        { productId, rating, reviewText, userName: resolvedName, userEmail: userEmail || '' }
      );
      await axios.post(
        `${API}/api/products/${productId}/feedback`,
        { userId, userName: resolvedName, userEmail: userEmail || '', productId, rating, comment: reviewText }
      ).catch(() => {});
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      alert(error.response?.data || 'Failed to submit review');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="review-modal">
      <div className="review-overlay" onClick={onClose}></div>
      <div className="review-container">
        <div className="review-header">
          <h3>Review: {productName || 'Product'}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit} className="review-form">
          <div className="rating-section">
            <label>Your Rating:</label>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`star ${star <= (hoverRating || rating) ? 'filled' : ''}`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                >★</span>
              ))}
            </div>
            <p className="rating-text">
              {rating === 0 ? 'Select a rating' : ['','Poor','Fair','Good','Very Good','Excellent'][rating]}
            </p>
          </div>
          <div className="review-text-section">
            <label>Your Review:</label>
            <textarea
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder="Share your experience with this product..."
              rows="5"
              maxLength="2000"
            />
            <p className="char-count">{reviewText.length}/2000</p>
          </div>
          <div className="review-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ReviewModal;
